<template>
<div>


	<div class="wpbox">
		<div class="go-back">
			<span @click="goBack"> {{  $t('Back') }}</span>
		</div>
		<div class="wp-title">{{ $t('Payment Method') }}</div>
		<div class="wp-split">
			<div class="page-content">
				<!-- <div class="page-box">
					<div class="box-month">
						<label class="box-title">{{ memberInfo.order_title }}</label>
						<ul>
							<li v-for="item in memberInfo.order_details" :key="item">{{ item }}</li>
						</ul>
					</div>
					<div class="box-pre">
						<div class="pre-title">{{ memberInfo.order_price_name }}</div>
						<div class="pre-text">{{ memberInfo.member_end_at }}</div>
					</div>
				</div> -->

				<!-- <div class="page-box">
					<label class="box-sub-title">{{ $t('Personal Infomation') }}</label>
					<el-input class="wp-input field-line" v-model="form.username" :placeholder="$t('Name')"></el-input>
					<div class="flex-2">
						<div class="field-line">
							<el-input class="wp-input" v-model="form.email" :placeholder="$t('Email')"></el-input>
						</div>
						<div class="field-line">
							<el-input class="wp-input" v-model="form.mobile" :placeholder="$t('Phone Number')"></el-input>
						</div>
					</div>
				</div> -->

				<div class="page-one">
					<!-- <div class="box-sub-title">{{ $t('Payment Method') }}</div> -->
					<div class="pay">
						<div class="pay-item">
							<el-radio v-model="form.pay_method" :label="1">{{ $t('Credit Card') }}</el-radio>
							<img src="../assets/img/visa.png" alt="" />
							<img src="../assets/img/mastercard.png" alt="" />
							<img src="../assets/img/american express.png" alt="" />
							<img src="../assets/img/discover.png" alt="" />
						</div>
            <!-- 样式骗你的 -->
            <Dropin :token="token" v-if="token"/>
						<div class="pay-item">
							<el-radio v-model="form.pay_method" :label="2">{{ $t('Alipay') }}</el-radio>
							<!-- <img src="../assets/img/alipay_logo_(2020) 1.png" alt="" /> -->
              <img src="../assets/img/ali_logo.png" alt="">
						</div>
						<!-- <div class="pay-item">
							<el-radio v-model="form.pay_method" :label="3">{{ $t('Wechatpay') }}</el-radio>
							<img src="../assets/img/wx_logo.png" alt="">
						</div> -->
					</div>
				</div>
				<div class="page-center" v-if="memberInfo.commission_is_show">
					<div>
						<p>{{$t('Price')}}:</p>
						<span>{{memberInfo.show_order_price }}  <span>{{$t('USD')}} </span>   </span>
					</div>
					<div>
						<p>{{$t('Processing Fee (3%)')}}:</p>
						<span>{{memberInfo.commission_price}} <span>  {{$t('USD')}}</span> </span>
					</div>
				</div>
				<div class="page-box">

					<div class="total-box">
						<div class="total-one">
							<span class="price-total">{{ $t('Total') }} :</span><span class="price">{{memberInfo.order_price  }}  <span>  {{ $t('USD')}} </span> </span>
						</div>
						<div class="agreement-text">
						{{ $t('By continuing, I accept terms in the') }}

						<a href="https://classover.com/en/privacy-refund-policy/"> {{ $t('Service Payment Agreement') }}</a>
						{{ $t('including Refund Policy. I have read the COPPA Direct Notice to Parent. I agree to subscribe to Classover newsletter, SMS messages, and accept the Terms of Use and Privacy Policy.') }}

						</div>
						<div class="pay-now">
							<el-button class="wp-button primary" :class="token || isDistable ? 'isDisabled' : ''" @click="buyNow">{{ $t('Pay Now') }}</el-button>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="mandy">
				<wp-mandy-mini></wp-mandy-mini>
			</div> -->

		</div>

		<!-- <div class="round pccss" >
			<img src="../assets/img/radio.png" alt="">
		</div> -->
	</div>
	<div class="foot">
				<wp-footer></wp-footer>
	</div>
</div>
</template>
<script src="https://js.braintreegateway.com/web/dropin/1.36.0/js/dropin.min.js"></script>
<script>
	import WpMandyMini from '../components/WpMandyMini.vue';

	import { buyMember, buyCredit, confirmOrder, stripePayment ,recordClick, creatBrainTreeOrder } from '../api';
	import { loadingData } from '../utils';
	import { getUser } from '../store/user';

	import WpFooter from '@/components/WpFooter.vue';

  import Dropin from '@/components/Dropin.vue'

	export default {
		components: { WpMandyMini,WpFooter,Dropin},
		name: 'Paymenthly',
		data() {
			return {
				memberInfo: {},
				form: {
					pay_method: 1,
					username: '',
					email: '',
					mobile: '',
					order_no: '',
				},
        token:'',
        isDistable:false
			};
		},
		async mounted() {
			let { id, type } = this.$route.query;

			await loadingData(async () => {
				this.memberInfo = await (type === 'member' ? buyMember(id) : buyCredit(id));
				this.form.order_no = this.memberInfo.order_no;
			});

			let user = getUser();
			let { name, email, mobile, country_code, user_sn } = user.user_info;
			this.form.username = name;
			this.form.email = email;
			this.form.mobile = `+${country_code} ${mobile}`;
			await recordClick(6,user_sn,'product-name:'+this.memberInfo.order_title);
		},
    watch:{
      'form.pay_method': {
        handler(newVal, oldVal) {
          console.log(newVal, oldVal)
          this.token = ''
          this.isDistable = false
        },
        deep: true
      }
    },
		methods: {
			goBack() {
				history.back();
			},
			async buyNow() {
        if(this.isDistable)return
        this.isDistable = true
				// loadingData(async () => {
        //   await confirmOrder(this.form);
				// 	let result = await stripePayment(this.form.order_no, 'pricing');
				// 	location.href = result.url;
				// });
        let result = await confirmOrder(this.form);
        if(result.payment_channel == 3){
          location.href = result.cashierUrl
          // this.isDistable = false
        }else{
          this.token = result.token
          console.log(result.token,'result.token');
          this.$set(this,'token',result.token)
          sessionStorage.setItem('order_no',result.order_no)
          // this.isDistable = false
        }
      }
    },
	}
</script>

<style lang="less" scoped>
*{
	font-family: Sofia Pro;
}
	.total-box {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		padding-bottom: 15px;
		> div {
			// margin-top: 18px;
			flex-grow: 1;
			text-align: center;
		}
		.agreement-text{
			margin-top: 24px;
			text-align: left;
		}
	}
	.wpbox{
		width: 90vw;
		margin: 0 auto;
	}
	.wp-title {
		margin-top: 37px;
		font-weight: 700;
		font-size: 20px;
		line-height: 30px;
	}
	// pc 端
	@media screen and (min-width: @device) {
		.foot{
			margin-top: 100px;
		}
		/deep/.el-button{
			font-weight: 600;
			font-size: 16px;
			line-height: 24px;
			span{
				font-family: Sofia Pro SemiBold;
			}

		}
		.total-box{
			margin-top: 24px;
			.total-one{
			// text-align: left;
			padding-top:18px;
			border-top: 1px solid #e6e6e6;
			display: flex;
			justify-content: space-between;

			font-style: normal;
			font-weight: 700;
			font-weight: bolder;
			font-size: 22px;
			line-height: 20px;
			color: #000000;
			span{
				font-family: 'Sofia Pro Bold';
				span{
				font-family: 'Sofia Pro SemiBold';
				}
			}
		}
		}

		.page-one{
			width: 600px;
			margin: 0 auto;
			margin-top: 52px;
			margin-bottom: 47px;

		}
		.go-back{
			margin-top: 97px;
			font-weight: 600;
			font-size: 16px;
		    line-height: 18px;
			span{
				font-family: Sofia Pro SemiBold;
			}
		}
		.wp-title{
			font-family: 'Sofia Pro Bold';
			font-weight: 700;
			font-size: 36px;
			line-height: 44px;
			color: #111827;
		}
		.pccss{
			display: none;
		}
		.mandy {
			width: 352px;
			min-width: 352px;
			margin-left: 99px;
		}

		.flex-2 {
			> * {
				width: 50%;
				box-sizing: border-box;

				&:first-child {
					padding-right: 5.5px;
				}

				&:last-child {
					padding-left: 5.5px;
				}
			}
		}

		.box-pre {
			text-align: right;
		}
			/deep/.el-avatar, .el-cascader-panel, .el-radio, /deep/.el-radio--medium.is-bordered .el-radio__label,/deep/.el-radio__label{
			font-size: 18px;
			line-height: 18px;
			color: #000000;
			font-family: Sofia Pro SemiBold;
		}
		.wp-title {
		margin-top: 72px;
	}


	}


	.price {
		// font-size: 28px;
		// font-weight: 600;
		span{
				font-family: 'Sofia Pro SemiBold';
				font-style: normal;
				font-weight: 500;
				font-size: 16px;
				line-height: 20px;
				color: #000000;
			}
	}

	// .price-total {
	// 	font-size: 20px;
	// 	font-weight: 400;
	// }

	.box-month {
		ul {
			color: #0b1d33;
			opacity: 0.6;
		}
	}



	.wp-split {
		display: flex;
		flex-direction: row;
		margin-bottom: 30px;
	}

	.page-content {
		// flex-grow: 2;
		// box-sizing: border-box;
		display: flex;
		flex-direction:column;
		width: 625px;
		margin: 0 auto;


	}
	.page-box {
		// border-top: 1px solid #e6e6e6;
		margin-top: 0px;
	}
	.page-center{
		border-top: 1px solid #e6e6e6;
		border-left: none;
		border-right: none;
		padding:24px 0 0;
		// margin-top: 47px;
		div{
			display: flex;
			justify-content:space-between;
			align-items: center;
		}
		p{
			font-family: 'Sofia Pro';
			font-style: normal;
			font-weight: 400;
			font-size: 16px;
			line-height: 20px;
			color: #000000;
		}
		span{
			font-family: 'Sofia Pro';
			font-style: normal;
			font-weight: 500;
			font-weight: bold;
			font-size: 16px;
			line-height: 20px;
			color: #000000;
			span{
				font-size: 16px;
			}
		}
	}
	.box-sub-title {
		display: block;
		font-weight: 600;
		font-size: 20px;
		line-height: 22px;
		margin-top: 30px;
	}


	.pre-text {
		margin-top: 17px;
		font-size: 14px;
		line-height: 15px;
		font-feature-settings: 'tnum' on, 'lnum' on;
	}

	.flex-2 {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.field-line {
		margin-top: 20px;
	}

	.pay-item {
		display: flex;
		align-items: center;
		margin-top: 25px;

		img + img {
			margin-left: 10px;
		}

		img {
			cursor: pointer;
      height: 21px;
		}
	}


	.t20 {
		margin-top: 30px;
	}

	.agreement-text {
		display: inline-block;
		font-weight: 400;
		font-size: 11px;
		line-height: 16px;
		color: #919191;
		text-align: left;
	}
	.pay-now{
		margin-top: 37px;
		.el-button{
			width: auto;
			padding: 13px 80px;
		}
	}


	// 移动端
	@media screen and (max-width: @device) {
		.page-one{
			margin-bottom:47px;
		}
		.wp-title{
			font-family: Sofia Pro Bold;
		}
		.page-center{
			p{
				font-size: 20px;
				width: 146px;
			}
			span{
				font-size: 20px;
				span{
					font-size: 14px;
				}
			}
		}
		.total-box {
			margin-top: 24px;
		.total-one{
			border-top: 1px solid #e6e6e6;
			// text-align: left;
			padding-top: 18px;
			span{
			font-family: 'Sofia Pro Bold';
			span{
				font-family: 'Sofia Pro SemiBold';
			}
			}
			display: flex;
			justify-content: space-between;
			align-items: center;

			font-style: normal;
			font-weight: 700;
			font-size: 24px;
			color: #000000;
			span{
			// 	display: flex;
			// align-items: center;
			}
		}
		}
		.round{
			position: absolute;
			top:0px;

			z-index: -1;
			right: 0px;
			overflow:hidden;
		}
		.go-back{
			// margin-left: 20px;
			margin-top: 42px;
			font-weight: 600;
            font-size: 16px;
			line-height: 18px;
			span{
				font-weight: 500;
            font-size: 16px;
			line-height: 18px;
			color: #4B4EFC;
			font-family: Sofia Pro SemiBold;
			}
		}
		.box-month{
			li{
				font-weight: 400;
				font-size: 14px;
				line-height: 29px;
				color: #8E8E8E;
			}
		}
		.box-pre{
			margin-top: 31px;
		}
		.pre-title{
			font-weight: 600;
			font-size: 20px;
			line-height: 35px;
			width: 300px;
            height: 35px;
			margin: 0px auto;
			text-align: center;
			padding-right: 20px;
		}
		.pre-text{
			font-weight: 400;
			font-size: 14px;
			line-height: 29px;
			color: #8E8E8E;
			margin-top: 40px;
		}
		.box-sub-title{
			font-size: 24px;
			margin-top: 50px;
		}
		.page-box{
			// width: 310px;
			margin: 0px auto 97px;
		}
		.agreement-text{
			margin: 0 auto;
			margin-top: 33px;
			font-weight: 400;
			width: 305px;

			font-size: 11px;
			line-height: 16px;
			color: #919191;
		}
		// .price-total{
		// 	font-weight: 600;
		// 	font-size: 24px;
		// 	line-height: 33px;
		// 	color: #000000;
		// }
		.total-box{
			margin-top: 20px;
		}
		.price{
			font-weight: 600;
			font-size: 24px;
			line-height: 20px;
			text-align: right;

			color: #000000;
			span{
				font-family: 'Sofia Pro SemiBold';
				font-style: normal;
				font-weight: 500;
				font-size: 14px;
				line-height: 20px;
				color: #000000;
			}

		}
		.wp-split {
			flex-wrap: wrap;
		}
		.pay{
			margin-top: 50px;
		}
		/deep/.el-radio__label{
			font-weight: 500;
            font-size: 14px;
            line-height: 18px;
			color: #000000;
			font-family: Sofia Pro SemiBold;
		}
		.total-box{
			.pay-now {
						width: 100%;
						margin-top: 32px;
					}
		}
		.total-box /deep/ .el-button--default{
			width: 301.26px;
			height: 46px;
			margin: 0px opx;
			span{
				font-weight: 600;
			font-size: 16px;
			line-height: 16px;
			font-family: Sofia Pro SemiBold;
			}
		}

		.wp-split {
			width: 95%;
			margin: auto;
		}

		.field-line {
			width: 100%;
		}

		.box-pre {
			text-align: center;
		}
		.page-content{
			width: 356px;
		}
	}
  //支付按钮动态样式
  .isDisabled{
    cursor: no-drop;
    color: #919191;
    background-color: #e6e6e6;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/Paymenthly.vue